import { useEffect, useState } from "react";
import axios from "axios";
import { env } from "../config";
import { useParams } from "react-router-dom";
import Categories from "../components/Categories";
import PostsMap from "../components/PostsMap";

const BLOG_TO_MAP_SLUGS = {
  arts: "museums-arts-galleries",
  "museums-arts-galleries": "museums-arts-galleries",
  concerts: "musics-dances-concerts",
  "music-dance": "musics-dances-concerts",
  "musics-dances-concerts": "musics-dances-concerts",
  cultures: "cultural-traditional-popular",
  "cultural-traditional-popular": "cultural-traditional-popular",
  "electronic-music": "electronic-music-nightlife",
  nightlife: "electronic-music-nightlife",
  "electronic-music-nightlife": "electronic-music-nightlife",
  festivals: "festivales",
  festivales: "festivales",
  "fiestas-mayors": "fiestas-mayors",
  "fiestas-mayor": "fiestas-mayors",
  gastronomy: "mercados",
  mercados: "mercados",
  "health-wellbeing": "sports-health-wellbeing",
  "sports-outdoors": "sports-health-wellbeing",
  "traditional-popular": "sports-health-wellbeing",
  "sports-health-wellbeing": "sports-health-wellbeing",
  "movies-cinemas": "auditoris-theaters-cinemas",
  "shows-theaters": "auditoris-theaters-cinemas",
  "auditoris-theaters-cinemas": "auditoris-theaters-cinemas",
};

const PostsByCategoorie = () => {
  const { key } = useParams();
  const [category, setCategory] = useState(null);
  const [posts, setPosts] = useState([]);
  const [mapPoints, setMapPoints] = useState([]);
  const [mapCategoryInfo, setMapCategoryInfo] = useState(null);
  const [targetMapSlug, setTargetMapSlug] = useState(BLOG_TO_MAP_SLUGS[key] || key);
  const [pageData, setPageData] = useState({
    current_page: 1,
    last_page: 0,
    total: 0,
  });

  const handlePageChange = (page) => {
    if (page !== pageData.current_page && page > 0 && page <= pageData.last_page) {
      setPageData((prevState) => ({
        ...prevState,
        current_page: page,
      }));
    }
  };

  useEffect(() => {
    if (!key) return;
    axios
      .get(`${env.baseUrl}/api/posts/${key}?page=${pageData.current_page || 1}`)
      .then((response) => {
        setCategory(response.data.category);
        const postsData = response.data.posts?.data || [];
        setPosts(postsData);
        setPageData({
          current_page: response.data.posts?.current_page || 1,
          last_page: response.data.posts?.last_page || 1,
          total: response.data.posts?.total || postsData.length,
        });

        const backendMapSlug = response.data.map_category_slug || BLOG_TO_MAP_SLUGS[key] || key;
        setTargetMapSlug(backendMapSlug);
      })
      .catch((error) => console.error("Error fetching category posts:", error));
  }, [key, pageData.current_page]);

  useEffect(() => {
    if (!targetMapSlug) return;
    axios
      .get(`${env.baseUrl}/api/maps/grouped/${targetMapSlug}`)
      .then((res) => {
        const groups = res.data.groups || [];
        const allPoints = [];
        groups.forEach((g) => {
          if (g.points && Array.isArray(g.points)) {
            g.points.forEach((p) => {
              allPoints.push({
                ...p,
                location: p.description || p.location || g.group_name,
              });
            });
          }
        });
        setMapPoints(allPoints);
        setMapCategoryInfo(res.data.category_all || null);
      })
      .catch(() => {
        setMapPoints([]);
      });
  }, [targetMapSlug]);

  return (
    <div>
      <section className="inner-banner">
        <div className="container">
          <div className="text-block">
            <h3><em>Category</em></h3>
            <h1>{category || key}</h1>
          </div>
        </div>
      </section>

      <section className="thisweek">
        <div className="container">
          <div className="lt-panel">
            <Categories type="posts" direction="vertical" activeItem={key} />
          </div>
          <div className="rt-panel">
            <div className="post-block">
              {posts.length === 0 && (
                <div className="p-4 text-center text-muted">
                  No articles found in this category yet.
                </div>
              )}

              <div className="d-block d-lg-block d-md-none">
                <div className="row">
                  {posts.map((post) => (
                    <div className="col-lg-4" key={post.id}>
                      <div className="post-box">
                        <div className="post-image position-relative">
                          <div className="img-block">
                            <figure className="thumbnail zoom-effect">
                              <a href={`/post/${post.slug}`}>
                                <img src={post.image || "/images/noimgpost.jpeg"} alt={post.title} />
                              </a>
                            </figure>
                            <div className="bordered-effect">
                              <a href={`/post/${post.slug}`} aria-label={post.title}></a>
                            </div>
                          </div>
                          <div className="post-content">
                            <div className="post-title">
                              <h2>
                                <a href={`/post/${post.slug}`}>{post.title}</a>
                              </h2>
                            </div>
                            <div className="post-category">{post.category_id}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="d-block d-md-block d-lg-none">
                <div className="row">
                  {posts.map((post) => (
                    <div className="col-sm-6" key={post.id}>
                      <div className="post-box">
                        <div className="post-image position-relative">
                          <div className="img-block">
                            <figure className="thumbnail zoom-effect">
                              <a href={`/post/${post.slug}`}>
                                <img src={post.image || "/images/noimgpost.jpeg"} alt={post.title} />
                              </a>
                            </figure>
                            <div className="bordered-effect">
                              <a href={`/post/${post.slug}`} aria-label={post.title}></a>
                            </div>
                          </div>
                          <div className="post-content">
                            <div className="post-title">
                              <h2>
                                <a href={`/post/${post.slug}`}>{post.title}</a>
                              </h2>
                            </div>
                            <div className="post-category">{post.category_id}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="d-block d-xs-none d-md-none">
                <div className="row">
                  {posts.map((post) => (
                    <div className="col-xs-12" key={post.id}>
                      <div className="post-box">
                        <div className="post-image position-relative">
                          <div className="img-block">
                            <figure className="thumbnail zoom-effect">
                              <a href={`/post/${post.slug}`}>
                                <img src={post.image || "/images/noimgpost.jpeg"} alt={post.title} />
                              </a>
                            </figure>
                            <div className="bordered-effect">
                              <a href={`/post/${post.slug}`} aria-label={post.title}></a>
                            </div>
                          </div>
                          <div className="post-content">
                            <div className="post-title">
                              <h2>
                                <a href={`/post/${post.slug}`}>{post.title}</a>
                              </h2>
                            </div>
                            <div className="post-category">{post.category_id}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {pageData.last_page > 1 && (
                <nav className="post-pagination" aria-label="post navigation">
                  <ul className="pagination">
                    <li className={`page-item ${pageData.current_page === 1 ? "disabled" : ""}`}>
                      <button
                        type="button"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(pageData.current_page - 1);
                        }}
                      >
                        &laquo; Previous
                      </button>
                    </li>

                    {[...Array(pageData.last_page)].map((_, index) => {
                      const pageNumber = index + 1;
                      return (
                        <li
                          key={pageNumber}
                          className={`page-item ${pageNumber === pageData.current_page ? "active" : ""}`}
                        >
                          <button
                            type="button"
                            className="page-link"
                            onClick={(e) => {
                              e.preventDefault();
                              handlePageChange(pageNumber);
                            }}
                          >
                            {pageNumber}
                          </button>
                        </li>
                      );
                    })}

                    <li
                      className={`page-item ${pageData.current_page === pageData.last_page ? "disabled" : ""}`}
                    >
                      <button
                        type="button"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(pageData.current_page + 1);
                        }}
                      >
                        Next &raquo;
                      </button>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
          </div>
          <div className="clearfix" />
        </div>
      </section>

      {/* Passive Guide Map for Category */}
      <section className="passive-map my-4">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
            <h4 style={{ margin: 0, fontWeight: 600 }}>
              Guide Map: {mapCategoryInfo?.name || category || "Barcelona"}
            </h4>
            {targetMapSlug && (
              <a
                href={`/maps-category/${targetMapSlug}`}
                className="btn btn-sm btn-outline-dark"
                style={{ fontSize: "13px" }}
              >
                Explore Full Interactive Guide Map &rarr;
              </a>
            )}
          </div>
          <PostsMap posts={mapPoints.length > 0 ? mapPoints : posts} />
        </div>
      </section>
    </div>
  );
};

export default PostsByCategoorie;
